import { Flex, Typography } from 'antd';
import type { FC } from 'react';
import { Icon } from 'components/icon';
import styled from 'styled-components';
import { StyledFileTileBody, StyledMask } from '../file_gallery/components/StyledWrappers';
import { getFileIconConfig } from './helpers';
import { useTheme } from 'styled-components';

const { Text } = Typography;

const StyledDocTileBody = styled(StyledFileTileBody)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 130px;
  height: 130px;
`;

const StyledFileNameOverlay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
`;

const StyledPreviewMask = styled(StyledMask)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  opacity: 0;

  ${StyledDocTileBody}:hover & {
    display: flex;
    opacity: 30%;
  }
`;

export interface FileCardProps {
  fileId: string;
  fileName?: string;
  onOpen?: () => void;
}

export const FileCard: FC<FileCardProps> = ({ fileId, fileName, onOpen }) => {
  const theme = useTheme();
  const iconConfig = getFileIconConfig(fileName, theme);

  const body = (
    <StyledDocTileBody key={fileId}>
      <Flex align="center" justify="space-around">
        <Icon $fontSize={theme.typography.fontSize[6]} color={iconConfig.color} iconString={iconConfig.iconString} />
      </Flex>
      {onOpen && <StyledPreviewMask />}
      <StyledFileNameOverlay>
        <Text>{fileName}</Text>
      </StyledFileNameOverlay>
    </StyledDocTileBody>
  );

  if (onOpen) {
    return (
      <button type="button" style={{ all: 'unset', cursor: 'pointer', display: 'block' }} onClick={onOpen}>
        {body}
      </button>
    );
  }

  return body;
};
